import { motion } from 'framer-motion'
import { useLanguage } from '../../../contexts/LanguageContext'
import MobileSlideShell from './MobileSlideShell'
import { fadeScaleProps, M_IMAGE_FRAME } from './mobileMotion'

export default function Slide2M() {
  const { t } = useLanguage()
  const s = t.slides.slide2
  const src = s.image || '/slides/slide_02.png'

  return (
    <MobileSlideShell>
      <motion.p
        {...fadeScaleProps(0)}
        className="text-[13px] font-bold uppercase tracking-[0.2em] text-[#1B2A6B]/50"
      >
        {s.eyebrow}
      </motion.p>

      <motion.h2
        {...fadeScaleProps(0.06)}
        className="text-[26px] font-semibold leading-tight tracking-tight text-[#1B2A6B]"
      >
        {s.headline}
      </motion.h2>

      <motion.div {...fadeScaleProps(0.1)} className={M_IMAGE_FRAME}>
        <img src={src} alt="" className="block w-full" loading="lazy" decoding="async" />
      </motion.div>

      <motion.p
        {...fadeScaleProps(0.14)}
        className="text-[16px] leading-relaxed text-[#1B2A6B]/70"
      >
        {s.body}{' '}
        <strong className="font-semibold text-[#1B2A6B]">50%</strong>{' '}
        {s.body2}
      </motion.p>

      <motion.p
        {...fadeScaleProps(0.2)}
        className="text-[16px] font-medium leading-relaxed text-[#1B2A6B]/80"
      >
        {s.tagline}
      </motion.p>
    </MobileSlideShell>
  )
}
